import Vue from "vue";
import Component from "vue-class-component";
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from "@/components/modal-permissions/modal-permissions.component.vue";
import ModalLoginComponent from "@/components/modal-login/modal-login.component.vue";
// External components
import Datepicker from "vuejs-datepicker";
// Services
import ProfileService from "@/core/services/profile.service.ts";
import SidebarService from "@/core/services/sidebar.service.ts";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    Datepicker,
  },
})
export default class ProfileComponent extends Vue {
  profileService: any = new ProfileService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  searchFlag: boolean = false;
  modal: boolean = false;
  deleteIcon: boolean = false;
  nextPositionDisabled: boolean = false;
  previousPositionDisabled: boolean = true;
  pagination: boolean = true;
  profileToDelete: any;
  searchFlag: any = [];
  profileList: any = [];
  filterProfileList: any = [];
  search: any = "";
  name: string = "";
  company: string = "";
  createdAt: string = "";
  searchByDate: any = "";
  filterConcatDate: string = "";
  pageOffset: number = 0;
  itemsPerPage: number = 50;
  totalPages: number;
  currentPage: number = 1;
  nextPage: number = 2;
  totalOfProfile: number = 0;
  itemsOfFrom: number = 0;
  itemsOfTo: number = 0;
  isTrainingSuperAdmin: boolean = false;

  mounted() {
    const _ = this;
    _.get(_.pageOffset, _.itemsPerPage);
    _.filterDate();
    _.isTrainingAdmin();
  }

  filterByDate() {
    const _ = this;
    _.deleteIcon = true;
    let day =
      _.searchByDate.getDate() < 10
        ? "0" + _.searchByDate.getDate()
        : _.searchByDate.getDate();
    let month =
      _.searchByDate.getMonth() < 10
        ? "0" + (_.searchByDate.getMonth() + 1)
        : _.searchByDate.getMonth() + 1;
    let year = _.searchByDate.getFullYear();
    _.filterConcatDate = `${year}-${month}-${day}`;
    _.filterProfileList = _.profileList.filter((profile) => {
      let parseDate: any = profile.createdAt.split("T");
      parseDate = parseDate[0];
      return _.filterConcatDate == parseDate;
    });
  }

  deleteDate() {
    const _ = this;
    _.filterConcatDate = "";
    _.deleteIcon = false;
    if (_.filterConcatDate == "") {
      _.searchByDate = "";
      _.filterProfileList = _.profileList;
      return;
    }
  }

  filterDate(date: any = "") {
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  openModal(id) {
    const _ = this;
    _.profileToDelete = id;
    _.modal = true;
  }

  get(pageOffset = 0, itemsPerPage = 50) {
    const _ = this;
    _.isLoading = true;
    _.profileService
      .get(pageOffset, itemsPerPage)
      .then((data: any) => {
        window.scrollTo({ top: 0 });
        _.profileList = data["data"].profiles;
        _.filterProfileList = data["data"].profiles;
        console.log(data, 'To get');
        _.totalOfProfile = data["data"].total;
        _.totalPages = Math.ceil(_.totalOfProfile / itemsPerPage);
        if (_.totalPages <= 1) {
          _.pagination = false;
        }
        if (pageOffset == 0) {
          _.itemsOfFrom = 1;
          _.itemsOfTo = _.profileList.length;
          _.previousPositionDisabled = true;
        }
        if (pageOffset != 0) {
          _.previousPositionDisabled = false;
        }
        if (pageOffset == _.totalPages - 1) {
          _.itemsOfTo = _.totalOfProfile;
        }
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        if (err.response.data.message.includes("Invalid or inexistent user")) {
          localStorage.removeItem("tk_auth");
          _.logInModal = true;
        }
        _.isLoading = false;
      });
  }

  delete_profile() {
    const _ = this;
    _.isLoading = true;
    console.log(_.profileToDelete, ' Profile delete');
    _.profileService
      .delete_profile(_.profileToDelete)
      .then((data: any) => {
        console.log('Then');
        _.get();
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.isLoading = false;
        console.log('Catch');
        _.get();
      });
  }

  nextPageAction() {
    const _ = this;
    _.itemsOfTo = _.itemsOfTo + _.profileList.length;
    _.itemsOfFrom = _.itemsOfFrom + _.profileList.length;
    _.pageOffset++;
    _.currentPage++;
    _.nextPage++;
    _.get(_.pageOffset);

    if (_.totalPages == _.currentPage) {
      _.nextPositionDisabled = true;
      return;
    }
  }

  previousPageAction() {
    const _ = this;
    if (_.currentPage == 1) {
      return;
    }
    _.itemsOfTo = _.itemsOfTo - _.profileList.length;
    _.itemsOfFrom = _.itemsOfFrom - _.profileList.length;
    _.pageOffset--;
    _.currentPage--;
    _.nextPage--;
    _.get(_.pageOffset);

    if (_.totalPages != _.currentPage) {
      _.nextPositionDisabled = false;
      return;
    }
  }

  private isTrainingAdmin() {
    const _ = this;
    const companyId = localStorage.getItem("company");
    if (companyId === "null" || companyId === "1") {
      _.isTrainingSuperAdmin = true;
    }
  }
}
